



























import Vue, { PropType } from 'vue';
import { formatJP } from '@/modules/currency';

// export type DataType = {
//   innerValue: string|number|null;
// };

export default Vue.extend({
  name: 'GPriceField',
  props: {
    value: { type: Number as PropType<number>, default: null },
    name: { type: String as PropType<string>, required: true },
    placeholder: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    max: { type: Number as PropType<number>, default: 999999999 },
    min: { type: Number as PropType<number>, default: 0 },
    // maxLength: { type: Number as PropType<number>, default: 0 },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    error: { type: Array as PropType<string[]>, default: () => [] },
  },
  watch: {
    innerValue(val: number | null) {
      if (val && val < this.min) {
        this.$nextTick(() => {
          this.innerValue = this.min;
        });
      } else if (val && val > this.max) {
        this.$nextTick(() => {
          this.innerValue = this.max;
        });
      }
    },
  },
  computed: {
    innerValue: {
      get(): number | null {
        return this.value;
      },
      set(val: number | null): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    formatJP(currency: number): string {
      return formatJP(currency);
    },
  },
});
